export default __webpack_public_path__ + "static/media/330_store03-en-mobile.b65b76b5.png";